import { backendApiGateway } from '~/client/backend';
import { NewSecondCompanySubscriptionInfoResponse, SubscriptionCustomerPortal } from '~/types/subscriptions';

export const fetchNewSecondCompanySubscriptionInfo = async () => {
  const { data: result } = await backendApiGateway.get<NewSecondCompanySubscriptionInfoResponse>(
    `/api/v1/subscriptions/second-company-info`,
  );

  return result;
};

export const fetchCustomerPortalUrl = async (subscriptionId: string, returnUrl: string) => {
  const { data } = await backendApiGateway.post<SubscriptionCustomerPortal>(
    `/api/v1/subscriptions/${subscriptionId}/customer-portal`,
    { url: returnUrl },
  );

  return data;
};
